"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const scrollTo_1 = __importDefault(require("./lib/scrollTo"));
// I do not know why but actualy typing args correctly causes problems. So it is unknown
// then typecast to the right object at the start of the block
exports.default = (_args) => {
    return {
        offset: 0,
        init() {
            this.setTop();
            this.setClickListener();
            this.offset = getHeaderHeight();
            window.addEventListener("resize", () => {
                this.offset = getHeaderHeight();
                this.setTop();
            });
        },
        setTop() {
            this.$el.style.top = getHeaderHeight() + "px";
        },
        setClickListener() {
            this.$el.addEventListener("click", event => {
                var _a;
                if (event.target && event.target instanceof HTMLAnchorElement) {
                    event.preventDefault();
                    const clickedItem = event.target;
                    const href = (_a = clickedItem.getAttribute("href")) === null || _a === void 0 ? void 0 : _a.replace("#", "");
                    if (href) {
                        const targetElement = document.getElementById(href);
                        if (targetElement) {
                            let offset;
                            if (location.pathname === "/") {
                                offset = 89;
                                // offset = getHeaderHeight();
                            }
                            else {
                                offset = this.offset + this.$el.offsetHeight;
                            }
                            console.log(this.offset, this.$el.offsetHeight, offset);
                            (0, scrollTo_1.default)(targetElement, -offset);
                        }
                    }
                }
            });
        },
    };
};
function getHeaderHeight() {
    const header = document.getElementById("header");
    const admin_header = document.getElementById("wpadminbar");
    const header_height = header ? header.offsetHeight : 0;
    const admin_height = admin_header ? 32 : 0;
    return header_height + admin_height;
}
